import Vue from 'vue'
import Vuex from 'vuex'
import utils from '@/core/h5/utils/index'
import cookies from "js-cookie";
import { bytesToSize } from "mpa-uploader/src/utils";

Vue.use(Vuex)

// cookies.set("deviceId", "9df6328b206493a0e176857abc2e97c0");
// cookies.set("token", "06f92f9977944239945c15c5217f16f2");
// cookies.set("spaceId", "0583d");
// cookies.set("userId", "1639856760128819318");

const store = new Vuex.Store({
    state: {
        isPcMode: true,
        headerTitle: 1,
        tabTitle: '最近使用',
        currentUserInfo: {},
        spaceId: cookies.get("spaceId"),
        userId: cookies.get("userId"),
        collapse: false,
        starWikiList: [],
        cloudHomeI18n: 'zh-cn',
        tasks: [],
        speeds: [],
        progresses: [],
    },
    mutations: {
        SET_STAR_WII_LIST(state, e) {
            state.starWikiList = e
        },
        SET_IS_PC_MODE(state, e) {
            state.isPcMode = e
        },
        SET_HEADER_TITLE(state, e) {
            state.headerTitle = e
        },
        SET_TAB_TITLE(state, e) {
            state.headerTitle = e
        },
        SET_COLLAPSE(state, e) {
            state.collapse = e
        },
        SET_CURRENT_USER_INFO(state, e) {
            state.currentUserInfo = e;
        },
        SET_CLOUD_HOME_I18N(state, e) {
            state.cloudHomeI18n = e;
        },
        // 上传任务处理
        NEW_TASKS(state, e) {
            state.tasks.push(...e);
        },
        REMOVE_TASKS(state, e) {
            const index = state.tasks.findIndex((task) => task.tid === e);
            state.tasks.splice(index, 1);
        },
        CHANGE_TASK_STATUS(state, e) {
            const task = state.tasks.find((task) => task.tid === e.tid);
            task.status = e.status;
        },

        CHANGE_UPLOAD_SPEED(state, e) {
            const speed = state.speeds.find((t) => t.tid === e.tid);
            if (speed) {
                speed.rate = bytesToSize(e.rate);
                speed.commit = e.commit;
            } else {
                state.speeds.push(e);
            }
        },

        CHANGE_UPLOAD_PROGRESS(state, e) {
            const progress = state.progresses.find((t) => t.tid === e.tid);
            if (progress) {
                progress.total = e.total;
                progress.uploaded = e.uploaded;
            } else {
                state.progresses.push(e);
            }
        },
    },
    actions: {
        setIsPcMode({ commit }) {
            const mode = utils.isPcMode()
            commit('SET_IS_PC_MODE', mode)
        },
        setStarWikiList({ commit }, value) {
            commit('SET_STAR_WII_LIST', value)
        },
        setHeaderTitle({ commit }, value) {
            commit('SET_HEADER_TITLE', value)
        },
        setTabTitle({ commit }, value) {
            commit('SET_TAB_TITLE', value)
        },
        setCollapse({ commit }, value) {
            commit('SET_COLLAPSE', value)
        },
        setCurrentUserInfo({ commit }, value) {
            commit('SET_CURRENT_USER_INFO', value);
        },
        setCloudHomeI18n({ commit }, value) {
            commit('SET_CLOUD_HOME_I18N', value)
        },

        newTasks({ commit }, value) {
            commit('NEW_TASKS', value);
        },
        removeTasks({ commit }, value) {
            commit('REMOVE_TASKS', value);
        },
        changeTaskStatus({ commit }, value) {
            commit('CHANGE_TASK_STATUS', value)
        },
        changeUploadSpeed({ commit }, value) {
            commit('CHANGE_UPLOAD_SPEED', value)
        },
        changeUploadProgress({ commit }, value) {
            commit('CHANGE_UPLOAD_PROGRESS', value)
        },
    }
})

export default store;